import MuiAlert from '@mui/material/Alert'

const CommonAlert = (props: any) => {
  return <MuiAlert elevation={6} variant='filled' {...props} />
}

export default CommonAlert
